import { constructEnum } from '@/lib/enum';

export default constructEnum('MediaSummaryStyle', {
  DEFAULT: 1,
  VERTICAL: 10
});
